import * as kcp from "./kcp";
import * as naver from "./naver";
import * as nice from "./nice";
import * as korpay from "./korpay";
import * as checkpay from "./checkpay";

export const plugins = {
    ...kcp,
    ...naver,
    ...nice,
    ...korpay,
    ...checkpay
}
